export default "__VITE_ASSET__DW1RTwtz__"